(function () {
  var KEY = 'breadcrumb_trail_v1';
  var RESET_KEY = 'breadcrumb_trail_reset_v1';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var HEADER_SELECTORS = [
    '#header',
    'theme-header',
    '#mobile-menu',
    '.mobile-menu-drawer',
    'footer',
    '.site-footer'
  ];

  function isInsideHeaderArea(el) {
    if (!el || !el.closest) return false;
    for (var i = 0; i < HEADER_SELECTORS.length; i++) {
      if (el.closest(HEADER_SELECTORS[i])) return true;
    }
    return false;
  }

  function setResetFlag() {
    try {
      sessionStorage.setItem(RESET_KEY, '1');
    } catch (e) {}
  }

  function consumeResetFlag() {
    try {
      if (sessionStorage.getItem(RESET_KEY)) {
        sessionStorage.removeItem(RESET_KEY);
        return true;
      }
    } catch (e) {}
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest
        ? e.target.closest('a[href*="/collections/"]')
        : null;
      if (!link) return;
      if (!isInsideHeaderArea(link)) return;
      setResetFlag();
    },
    true
  );

  function readTrail() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      if (!data || !data.timestamp) return [];
      if (Date.now() - data.timestamp > MAX_AGE_MS) {
        sessionStorage.removeItem(KEY);
        return [];
      }
      return data.items || [];
    } catch (e) {
      return [];
    }
  }

  function writeTrail(items) {
    try {
      sessionStorage.setItem(
        KEY,
        JSON.stringify({ items: items, timestamp: Date.now() })
      );
    } catch (e) {}
  }

  function collectionHandleFromPath(path) {
    if (!path) return null;
    var m = path.match(/^\/collections\/([^\/?#]+)/);
    if (!m) return null;
    var handle = decodeURIComponent(m[1]);
    if (handle === 'all') return null;
    return handle;
  }

  function getCurrentCollection() {
    var body = document.body;
    if (!body) return null;
    var handle = body.getAttribute('data-collection-handle');
    if (!handle) return null;
    var title = body.getAttribute('data-collection-title') || handle;
    return { handle: handle, title: title, url: '/collections/' + handle };
  }

  function getReferrerCollectionHandle() {
    try {
      if (!document.referrer) return null;
      var u = new URL(document.referrer);
      if (u.host !== window.location.host) return null;
      return collectionHandleFromPath(u.pathname);
    } catch (e) {
      return null;
    }
  }

  function updateTrail() {
    var current = getCurrentCollection();
    if (!current) return;

    if (consumeResetFlag()) {
      writeTrail([current]);
      return;
    }

    var trail = readTrail();

    var existingIdx = -1;
    for (var i = 0; i < trail.length; i++) {
      if (trail[i].handle === current.handle) {
        existingIdx = i;
        break;
      }
    }

    if (existingIdx >= 0) {
      trail = trail.slice(0, existingIdx + 1);
      trail[trail.length - 1].title = current.title;
      writeTrail(trail);
      return;
    }

    var refHandle = getReferrerCollectionHandle();
    if (
      refHandle &&
      trail.length &&
      trail[trail.length - 1].handle === refHandle
    ) {
      trail.push(current);
    } else {
      trail = [current];
    }
    writeTrail(trail);
  }

  function renderAncestors() {
    var placeholder = document.querySelector('[data-breadcrumb-trail]');
    if (!placeholder) return;
    var targetHandle = placeholder.getAttribute('data-target-handle');
    if (!targetHandle) return;

    var trail = readTrail();
    if (!trail.length) return;

    var targetIdx = -1;
    for (var i = 0; i < trail.length; i++) {
      if (trail[i].handle === targetHandle) {
        targetIdx = i;
        break;
      }
    }
    if (targetIdx <= 0) return;

    var frag = document.createDocumentFragment();
    for (var j = 0; j < targetIdx; j++) {
      var slash = document.createElement('i');
      slash.textContent = '/';
      frag.appendChild(slash);

      var a = document.createElement('a');
      a.setAttribute('href', trail[j].url);
      a.setAttribute('title', trail[j].title);
      a.textContent = trail[j].title;
      frag.appendChild(a);
    }
    placeholder.appendChild(frag);
  }

  function run() {
    updateTrail();
    renderAncestors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
